import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { Button, Box, Notification, StackView } from '@telus-uds/components-web';
import moment from 'moment';

import {
  CommentMain,
  CommentHeader,
  CommenterName,
  CommentDate,
  CommentBody
} from '../../../css';
import request from '../../../../../../../utils/request';
import { useLocalizedStringsContext } from '../../../../../../../context/LocalizedStringsContext';

const CommentsList = ({ orderData, newCommentAdded }) => {
  const INITIAL_COMMENTS = 3;
  const {
    iotOrderDetailsSection: {
      labelNoCommentsFound,
      labelShowMore,
      labelShowLess
    }
  } = useLocalizedStringsContext();

  const [commentsList, setCommentsList] = useState([]);
  const [numberOfCommentToShow, setNumberOfCommentToShow] = useState(
    INITIAL_COMMENTS
  );
  const [error, setError] = useState(null);

  const getComments = async () => {
    try {
      const { id } = orderData;
      if (!id) return;
      const result = await request.get(`/orders/${id}/comments`);
      if (result) setCommentsList(_.get(result, 'data.results', []));
    } catch (err) {
      setError('Error while fetching comments');
    }
  };

  const getCommentsName = userDetails =>
    `${userDetails.first_name} ${userDetails.last_name}`;

  const loadComments = type => {
    setNumberOfCommentToShow(previousValue => {
      if (type === 'more') return previousValue + 1;
      return INITIAL_COMMENTS;
    });
  };

  useEffect(() => {
    getComments();
  }, [orderData, newCommentAdded]);

  return (
    <StackView space={3}>
      {commentsList && commentsList.length === 0 && (
        <p>{labelNoCommentsFound}</p>
      )}
      {!error &&
        commentsList &&
        commentsList.map((comment, index) => {
          if (index + 1 > numberOfCommentToShow) return null;
          return (
            <CommentMain key={comment.id}>
              <CommentHeader>
                <CommenterName>{getCommentsName(comment.user)}</CommenterName>
                <CommentDate>
                  {moment(comment.createdAt).format(
                    'dddd, MMMM Do YYYY, h:mm:ss a'
                  )}
                </CommentDate>
              </CommentHeader>
              <CommentBody>{comment.text}</CommentBody>
            </CommentMain>
          );
        })}
      {numberOfCommentToShow < commentsList.length && (
        <div
          style={{
            display: 'flex'
          }}
        >
          <Button variant={{ text: true }} onPress={() => loadComments('more')}>
            {labelShowMore}
          </Button>
        </div>
      )}
      {commentsList.length !== 0 &&
        commentsList.length === numberOfCommentToShow && (
          <div
            style={{
              display: 'flex'
            }}
          >
            <Button variant={{ text: true }} onPress={() => loadComments('less')}>
              {labelShowLess}
            </Button>
          </div>
        )}
      {error && (
        <Notification variant={{ validation: 'error' }}>
          {error}
        </Notification>
      )}
    </StackView>
  );
};

CommentsList.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.any).isRequired,
  newCommentAdded: PropTypes.bool.isRequired
};

export default CommentsList;
